import * as React from 'react';

import * as TogglePrimitive from '@radix-ui/react-toggle';
import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib/utils';

const toggleVariants = cva(
  'vai-font-inter vai-inline-flex vai-items-center [:where(&)]:vai-justify-center vai-rounded-md vai-text-sm vai-font-medium vai-ring-offset-background vai-transition-colors [:where(&)]:hover:vai-bg-muted [:where(&)]:hover:vai-text-muted-foreground focus-visible:vai-outline-none focus-visible:vai-ring-2 focus-visible:vai-ring-ring focus-visible:vai-ring-offset-2 disabled:vai-pointer-events-none disabled:vai-opacity-50 [:where(&)]:data-[state=on]:vai-bg-accent data-[state=on]:vai-text-accent-foreground [&_svg]:vai-pointer-events-none [&_svg]:vai-size-4 [&_svg]:vai-shrink-0 vai-gap-2',
  {
    variants: {
      variant: {
        default: 'vai-bg-transparent',
        outline:
          'vai-border vai-border-input vai-bg-transparent [:where(&)]:hover:vai-bg-accent [:where(&)]:hover:vai-text-accent-foreground',
      },
      size: {
        default: 'vai-h-10 vai-px-3 vai-min-w-10',
        sm: 'vai-h-9 vai-px-2.5 vai-min-w-9',
        lg: 'vai-h-11 vai-px-5 vai-min-w-11',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
));

Toggle.displayName = TogglePrimitive.Root.displayName;

export { Toggle, toggleVariants };
